import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'

const rootElement = document.getElementById('root')
if (rootElement) {
  try {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    )
  } catch (error) {
    console.error('Error rendering app:', error);
    // Fallback rendering without StrictMode
    ReactDOM.createRoot(rootElement).render(<App />);
  }
} else {
  console.error('Root element not found')
  // Create error message in DOM
  document.body.innerHTML = `
    <div style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100vh;
      background: #000;
      color: #fff;
      font-family: Arial, sans-serif;
      text-align: center;
    ">
      <div>
        <h1 style="color: #EE1C23; margin-bottom: 20px;">Cybertronic</h1>
        <p>Aplikace se načítá...</p>
        <p style="font-size: 12px; color: #666; margin-top: 20px;">
          Pokud se stránka nenačte, zkuste obnovit stránku.
        </p>
      </div>
    </div>
  `;
}